import { useColorModeValue } from "@chakra-ui/react";

/**
 * Estilo padronizado das seções de etapas internas de RH.
 *
 * Sistema único:
 *  - pendente  → laranja claro: a etapa ainda não foi concluída (chama atenção).
 *  - concluída → verde: a etapa está feita.
 *
 * Usar em todas as seções (RecruiterSection, etc.) para garantir cores
 * idênticas entre etapas.
 */
export function useHrSectionStyles(completed: boolean) {
  const bg = useColorModeValue(
    completed ? "green.50" : "orange.50",
    completed ? "rgba(72,187,120,0.08)" : "rgba(251,146,60,0.08)",
  );
  const borderColor = useColorModeValue(
    completed ? "green.200" : "orange.200",
    completed ? "green.800" : "orange.800",
  );
  const titleColor = useColorModeValue(
    completed ? "green.700" : "orange.700",
    completed ? "green.300" : "orange.300",
  );
  const subColor = useColorModeValue(
    completed ? "green.600" : "orange.600",
    completed ? "green.300" : "orange.300",
  );

  return { bg, borderColor, titleColor, subColor };
}